import React from "react";
import { useState, useEffect } from "react";
import Activities1 from "./Activities1";
import Activities2 from "./Activities2";
import Activities3 from "./Activities3";
import Activities4 from "./Activities4";
import Activities5 from "./Activities5";
import Activities6 from "./Activities6";
import { CMSPath } from "../../../config/constant";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { setGoHome } from "../../action/homeAction";

 



function Activities(props){
    
    const [currentPage, setCurrentPage]=useState(1);
    const [bookingData, setBookingData]=useState({})
    const [activitiesAvailable, setActivitiesAvailable]=useState(null);
    const [cachedApiDataStore, setCachedApiDataStore] = useState({}); //key are activity_locations , my_reservations
 

    const next=(selectedFields)=>{
        if(selectedFields){
            const updatedBookingData= {...bookingData, ...selectedFields};
            setBookingData(updatedBookingData);
        }
        setCurrentPage(currentPage+1)
    }
    const handleGoBack=()=>{
        if ((currentPage == 1) || (currentPage == 2 && props.currentWidgets.spaLocationId) ){
            props.setGoHome(true);
            return ;
        }
        if(currentPage==6){
            
            console.log("location is ", bookingData.spaLocationId)
            setBookingData({
                
                spaLocationId: bookingData.spaLocationId,
                spaName: bookingData.spaName,
                spaDescription: bookingData.spaDescription
            
            });
            setActivitiesAvailable(null);
            setCurrentPage(2);
            return;
        }

        setCurrentPage(currentPage-1);
    }

   
    useEffect(()=>{console.log("Activities...")},[])

    return (
        
        <>
           
        {/* Page=1 ->  select SPA LOCATION ID*/}
            {currentPage == 1 && <Activities1 cachedApiDataStore={cachedApiDataStore} setCachedApiDataStore={setCachedApiDataStore}  next={next} handleGoBack={handleGoBack} />}

        {/* Page=2 -> see MY RESERVATION + cancel + update popup*/}
        {/* adds existingReservationDetails in bookingData */}
            {currentPage == 2 && <Activities2 cachedApiDataStore={cachedApiDataStore} setCachedApiDataStore={setCachedApiDataStore}  next={next}  bookingData={bookingData} handleGoBack={handleGoBack} />}

        {/* Page=3 -> select preferred date and no of guests */}
            {currentPage == 3 && <Activities3 next={next}  setActivitiesAvailable={setActivitiesAvailable} bookingData={bookingData} handleGoBack={handleGoBack} />}

        {/* Page=4 -> select final Activity*/}
            {currentPage == 4 && <Activities4 activitiesAvailable={activitiesAvailable} bookingData={bookingData} next={next} handleGoBack={handleGoBack} />}

        {/* Page=5 ->   summary*/}
            {currentPage == 5 && <Activities5 cachedApiDataStore={cachedApiDataStore} setCachedApiDataStore={setCachedApiDataStore} bookingData={bookingData} next={next} handleGoBack={handleGoBack} />}

        {/* Page=6 -> success page*/}
            {currentPage == 6 && <Activities6 bookingData={bookingData}  next={next} handleGoBack={handleGoBack} />}

        </>
    )
}
const mapStateToProps= (state)=>{
    return{
        logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}
export default connect(mapStateToProps, { setGoHome })(withTranslation("translations")(Activities));

